import React, { useRef, useState, useEffect } from 'react';

const VideoPlayer = ({ src, poster, width = '100%', loop = true, maxHeight }) => {
  const videoRef = useRef(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.loop = loop;
      videoRef.current.muted = true;
      videoRef.current.volume = 0;
      videoRef.current.play().catch((err) => {
        setHasError(true);
        console.error('Video play failed:', err);
      });
    }
  }, [loop, src]);

  return (
    <div
      className="video-player"
      style={{
        width,
        maxWidth: '100%',
        maxHeight: maxHeight || '70vh',
        overflow: 'hidden',
      }}
    >
      {hasError ? (
        <div
          style={{
            padding: '3rem',
            textAlign: 'center',
            background: 'linear-gradient(135deg, #172243, #2a1771)',
            color: '#fff',
            minHeight: 280,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          Error loading video.
        </div>
      ) : (
        <video
          ref={videoRef}
          src={src}
          poster={poster}
          controls={false}
          onError={() => setHasError(true)}
          autoPlay
          muted
          playsInline
          style={{
            width: '100%',
            height: maxHeight ? '100%' : 'auto',
            minHeight: 220,
            objectFit: 'cover',
            display: 'block',
          }}
        />
      )}
    </div>
  );
};

export default VideoPlayer;
